import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";

//UI
import { Button, Modal, Table, Loader, Icon, Form, Divider, List, Message } from "semantic-ui-react";
import HeaderCatalog from "../../../components/headerCatalog";
import ActiveIcon from "../../../components/activeIcon";
import { useTranslation } from "react-i18next";
import StateRateCell from "../../../components/rates/stateRateCell"
import ChangeStateRateModal from "../../../components/rates/changeStateRateModal"

//Actions
import { deleteContractRate } from "../../../redux/actions/rates/contractRates/deleteContractRate";
import { initialStateContractRate } from "../../../redux/actions/rates/contractRates/fetchContractRate";
import { fetchContractRateListCustom, initialStateContractRateListCustom } from "../../../redux/slices/custom/rates/contractRate/customContractRateList.slice";

import GeneralRateCell from "../../../components/rates/generalRateCell"

// Resources
import { scrollToTop } from "../../resources/utils";

export default function ContractList() {
  const { t } = useTranslation();
  let actualDate = new Date();
  let currentYear = actualDate.getFullYear();
  let yacht = "";
  let agency = "";
  let days = "all";
  let state = 1;

  const contractRateFilters = JSON.parse(localStorage.getItem("contractRateFilters"));
  if (contractRateFilters) {
    currentYear = contractRateFilters.year;
    yacht = contractRateFilters.yacht;
    agency = contractRateFilters.agency;
    days = contractRateFilters.days;
    state = contractRateFilters.state;
  }

  const { register, handleSubmit, errors, getValues } = useForm();
  const contractStateCustom = useSelector((state) => state.customContractRateList);;
  const contractState = useSelector((state) => state.contractRateReducer);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchContractRateListCustom({ year: currentYear, yacht_id: yacht, agency_id: agency, days: days, state: state }, ""));
    scrollToTop();
    return () => {
      dispatch(initialStateContractRateListCustom())
      dispatch(initialStateContractRate());
    };
  }, []);

  if (contractStateCustom.fetching || contractState.fetching) {
    return <Loader active inline />;
  }


  if (contractState.message === "resource deleted successfully") {
    dispatch(
      fetchContractRateListCustom({ year: getValues("year"), yacht_id: getValues("yacht_id"), agency_id: getValues("agency_id"), days: getValues("days"), state: getValues("state") }, "")
    );
    dispatch(initialStateContractRate());
  }

  if (contractState.message === "resource updated successfully") {
    dispatch(
      fetchContractRateListCustom({ year: getValues("year"), yacht_id: getValues("yacht_id"), agency_id: getValues("agency_id"), days: getValues("days"), state: getValues("state") }, "")
    );
    dispatch(initialStateContractRate());
  }

  const onSubmit = (data) => {
    let contractRateFilters = {
      year: getValues("year"),
      yacht: getValues("yacht_id"),
      agency: getValues("agency_id"),
      days: getValues("days"),
      state: getValues("state")
    };
    localStorage.setItem("contractRateFilters", JSON.stringify(contractRateFilters));
    dispatch(fetchContractRateListCustom(data, ""));
  };

  const handledeleteContract = (contract_id) => {
    dispatch(deleteContractRate(contract_id));
  };

  return (
    <>
      {contractState.error ? (
        <Message negative content={t(contractState.error)} />
      ) : (
        ""
      )}
      <HeaderCatalog title={t("contract_title")} message={contractStateCustom.message} to="/contractRates/contractRates_new" />
      <Divider />
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Form.Group widths="equal">
          <Form.Field>
            <label>{t("contract_year")}</label>
            <select name="year" defaultValue={currentYear} aria-expanded="true" ref={register}>
              {contractStateCustom.years.map((year, index) => (
                <option key={index} value={year.year}>{year.year}</option>
              ))}
            </select>
          </Form.Field>
          <Form.Field required>
            <label>{t("contract_yacht")}</label>
            <select name="yacht_id" defaultValue={yacht} aria-expanded="true" ref={register({ required: true })}>
              <option />
              {contractStateCustom.yachts.map((yacht) => (
                <option key={yacht.id} value={yacht.id}>{t(yacht.name)}</option>
              ))}
            </select>
            {errors.rate_id && (<span className="error_message">{t("required_information")}</span>)}
          </Form.Field>
          <Form.Field required>
            <label>{t("contract_agency")}</label>
            <select name="agency_id" defaultValue={agency} aria-expanded="true" ref={register({ required: true })}>
              <option />
              {contractStateCustom.agencies.map((agency) => (
                <option key={agency.id} value={agency.id}>{agency.name}</option>
              ))}
            </select>
            {errors.rate_id && (<span className="error_message">{t("required_information")}</span>)}
          </Form.Field>
          <Form.Field>
            <label>{t("contract_days")}</label>
            <select name="days" defaultValue={days} aria-expanded="true" ref={register}>
              <option value="all">{t("all")}</option>
              {contractStateCustom.days.map((day, index) => (
                <option key={index} value={day.number_days}>{t(day.number_days)}</option>
              ))}
            </select>
          </Form.Field>
          <Form.Field>
            <label>{t("charter_state")}</label>
            <select name="state" defaultValue={state} aria-expanded="true" ref={register}>
              <option value="all">{t("all")}</option>
              <option value={1}>{t("active_tag")}</option>
              <option value={0}>{t("inactive_tag")}</option>
            </select>
          </Form.Field>
          <Form.Field>
            <label>&nbsp;</label>
            <Button type="submit" loading={contractStateCustom.fetching ? true : false} color="green"><Icon name='search' />{t("search_button")}</Button>
          </Form.Field>
        </Form.Group>
      </Form>

      {contractStateCustom.contractRates !== undefined ? (
        <Table color="blue">
          <Table.Body>
            {contractStateCustom.contractRates.map((contractRate) => (
              <>
                <Table.Row>
                  <Table.Cell colSpan='8'>
                    <div className="flex justify-between">
                      <div className=" flex flex-col p-2 ">
                        <h1 className="text-[18px]">{contractRate.yacht_name}</h1>
                        <p className="font-semibold text-[15px] mt-[-13px]">{t("general_days")}: {contractRate.days}</p>
                        <StateRateCell activation_date={contractRate.activation_date} inactivation_date={contractRate.inactivation_date} reason_deactivation={contractRate.reason_deactivation} />
                      </div>
                      <div className=" flex items-center pr-6">
                        <List size="large">
                          <List.Item>
                            <List.Icon color='red' name={contractRate.airplane_ticket === 1 ? 'plane' : 'dont'} />
                            <List.Content>
                              <List.Description>{contractRate.airplane_ticket === 1 ? t("general_priceInclude") : t("general_priceNotInclude")} </List.Description>
                            </List.Content>
                          </List.Item>
                        </List>
                      </div>
                    </div>
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.HeaderCell className="pl-10"></Table.HeaderCell>
                  <Table.HeaderCell className="pl-3">{t("contract_year")}</Table.HeaderCell>
                  <Table.HeaderCell className="pl-3">{t("contract_agency")}</Table.HeaderCell>
                  <Table.HeaderCell className="pl-10">{t("contract_charter")}</Table.HeaderCell>
                  <Table.HeaderCell className="pl-10">{t("contract_double")}</Table.HeaderCell>
                  <Table.HeaderCell className="pl-10">{t("contract_single")}</Table.HeaderCell>
                  <Table.HeaderCell className="pl-10"></Table.HeaderCell>
                </Table.Row>
                <Table.Row key={contractRate.id} className='no-row-borders'>
                  <Table.Cell collapsing><ActiveIcon active={contractRate.active} /></Table.Cell>
                  <Table.Cell>{contractRate.year}</Table.Cell>
                  <Table.Cell>{contractRate.agency_name}
                    <div>
                      <span className="ticket_title">{t(contractRate.contract)}</span>
                    </div>
                  </Table.Cell>
                  <Table.Cell align="center"><GeneralRateCell client={contractRate.charter_client} operator={contractRate.charter_operator} /></Table.Cell>
                  <Table.Cell align="center"><GeneralRateCell client={contractRate.double_client} operator={contractRate.double_operator} /></Table.Cell>
                  <Table.Cell align="center"><GeneralRateCell client={contractRate.single_client} operator={contractRate.single_operator} /></Table.Cell>
                  <Table.Cell collapsing>
                    {contractRate.active != false ? (
                      <ChangeStateRateModal stateRate={contractRate} stateError={contractState.error} typeRate="ContractRate" />
                    ) : (
                      null
                    )}
                    {(!contractRate.active && !contractRate.reason_deactivation) && (
                      <>
                        <Link to={`/contractRates/${contractRate.id}`}><Button circular color='blue' icon='pencil alternate' /></Link>
                        <Modal
                          trigger={
                            <Button circular color='red' icon='trash alternate' />
                          }
                          content={t("contract_delete")}
                          actions={[
                            t("canceled_button"),
                            {
                              key: "eliminar",
                              content: t("delete_button"),
                              className: "delete_button icon_color",
                              onClick: () => handledeleteContract(contractRate.id),
                            },
                          ]}
                          size="tiny"
                        />
                      </>
                    )}
                  </Table.Cell>
                </Table.Row>
              </>
            ))}
          </Table.Body>
        </Table>
      ) : (
        ""
      )}
    </>
  );
}
